const STATES = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
};
const TERRITORIES = {
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands',
    PR: 'Puerto Rico',
    VI: 'Virgin Islands',
};
const sortByLabel = (a, b) => {
    const labelA = a.label;
    const labelB = b.label;
    if (labelA < labelB) {
        return -1;
    }
    if (labelA > labelB) {
        return 1;
    }
    return 0;
};
const STATES_AND_TERRITORIES = { ...STATES, ...TERRITORIES };
const STATES_SHORT = Object.keys(STATES).map((key) => key).sort();
const STATES_LONG = Object.values(STATES).map((value) => value);
const STATES_SHORT_LABELS = Object.keys(STATES)
    .map((key) => ({ value: key, label: key }))
    .sort(sortByLabel);
const STATES_LONG_LABELS = Object.values(STATES)
    .map((value) => ({ value, label: value }))
    .sort(sortByLabel);
const STATES_SHORT_VALUES_LONG_LABELS = Object.entries(STATES)
    .map(([short, long]) => ({ value: short, label: long }))
    .sort(sortByLabel);
const STATES_LONG_VALUES_SHORT_LABELS = Object.entries(STATES)
    .map(([short, long]) => ({ value: long, label: short }))
    .sort(sortByLabel);
const TERRITORIES_SHORT = Object.keys(TERRITORIES).map((key) => key);
const TERRITORIES_LONG = Object.values(TERRITORIES).map((value) => value);
const TERRITORIES_SHORT_LABELS = Object.keys(TERRITORIES).map((key) => ({ value: key, label: key }));
const TERRITORIES_LONG_LABELS = Object.values(TERRITORIES).map((value) => ({ value, label: value }));
const TERRITORIES_SHORT_VALUES_LONG_LABELS = Object.entries(TERRITORIES)
    .map(([short, long]) => ({ value: short, label: long }));
const TERRITORIES_LONG_VALUES_SHORT_LABELS = Object.entries(TERRITORIES)
    .map(([short, long]) => ({ value: long, label: short }));
const STATES_AND_TERRITORIES_SHORT = [...STATES_SHORT, ...TERRITORIES_SHORT].sort();
const STATES_AND_TERRITORIES_LONG = [...STATES_LONG, ...TERRITORIES_LONG].sort();
const STATES_AND_TERRITORIES_SHORT_LABELS = STATES_AND_TERRITORIES_SHORT
    .map((el) => ({ value: el, label: el }))
    .sort(sortByLabel);
const STATES_AND_TERRITORIES_LONG_LABELS = STATES_AND_TERRITORIES_LONG
    .map((el) => ({ value: el, label: el }))
    .sort(sortByLabel);
const STATES_AND_TERRITORIES_SHORT_VALUES_LONG_LABELS = Object.entries(STATES_AND_TERRITORIES)
    .map(([short, long]) => ({ value: short, label: long }))
    .sort(sortByLabel);
const STATES_AND_TERRITORIES_LONG_VALUES_SHORT_LABELS = Object.entries(STATES_AND_TERRITORIES)
    .map(([short, long]) => ({ value: long, label: short }))
    .sort(sortByLabel);
const US = {
    STATES_SHORT,
    STATES_LONG,
    STATES_LONG_LABELS,
    STATES_SHORT_LABELS,
    STATES_LONG_VALUES_SHORT_LABELS,
    STATES_SHORT_VALUES_LONG_LABELS,
    TERRITORIES_SHORT,
    TERRITORIES_LONG,
    TERRITORIES_SHORT_LABELS,
    TERRITORIES_LONG_LABELS,
    TERRITORIES_LONG_VALUES_SHORT_LABELS,
    TERRITORIES_SHORT_VALUES_LONG_LABELS,
    STATES_AND_TERRITORIES_SHORT,
    STATES_AND_TERRITORIES_LONG,
    STATES_AND_TERRITORIES_SHORT_LABELS,
    STATES_AND_TERRITORIES_LONG_LABELS,
    STATES_AND_TERRITORIES_SHORT_VALUES_LONG_LABELS,
    STATES_AND_TERRITORIES_LONG_VALUES_SHORT_LABELS,
};
export default US;
